import { useShouldShowSaleAnnouncementNudge } from "@faire/deprecated-retailer-visitor-shared/components/Header/desktop/SaleAnnouncementNudge/useShouldShowSaleAnnouncementNudge";
import { useMilestone } from "@faire/marketplace-lib/stores/useMilestone";
import { Core } from "@faire/slate/foundation/color";
import { trackFlashSalesSaleAnnouncementTooltipClick } from "@faire/web-api--source/events/flashSales/click/saleAnnouncementTooltip";
import { trackFlashSalesSaleAnnouncementTooltipDismiss } from "@faire/web-api--source/events/flashSales/dismiss/saleAnnouncementTooltip";
import { trackFlashSalesSaleAnnouncementTooltipView } from "@faire/web-api--source/events/flashSales/view/saleAnnouncementTooltip";
import { SALE_ANNOUNCEMENT_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SALE_ANNOUNCEMENT_DISMISSED";
import { path as c1CategoryPath } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate-deprecated/Button";
import { DismissableTooltip } from "@faire/web/slate-deprecated/Tooltip";
import ClickOutside from "@faire/web/ui/ClickOutside";
import { useDoActionWhenVisible } from "@faire/web/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const SaleAnnouncementTooltip = () => {
  const { shouldShowSalesHubNudge, shouldShowPowerUserNudge } =
    useShouldShowSaleAnnouncementNudge();
  const viewRef = useDoActionWhenVisible(
    trackFlashSalesSaleAnnouncementTooltipView
  );
  const { setHasOccurred: dismissSaleAnnouncement } = useMilestone(
    SALE_ANNOUNCEMENT_DISMISSED
  );
  const tooltipContent = useGetTooltipContent(shouldShowPowerUserNudge);
  const handleDismiss = () => {
    if (shouldShowSalesHubNudge) {
      trackFlashSalesSaleAnnouncementTooltipDismiss();
      void dismissSaleAnnouncement();
    }
  };

  const handleClick = () => {
    trackFlashSalesSaleAnnouncementTooltipClick();
    void dismissSaleAnnouncement();
  };

  if (!shouldShowSalesHubNudge) {
    return null;
  }

  return (
    <ClickOutside onClickOutside={handleDismiss}>
      <StyledTooltip
        position="bottom"
        targetNode={<div ref={viewRef} />}
        onDismiss={handleDismiss}
        contents={tooltipContent}
        action={
          <Button
            variant="tertiary"
            tertiaryColor={Core.text.primaryInverse}
            target="_blank"
            linkTo={c1CategoryPath("sale")}
            onClick={handleClick}
          >
            <StrictLocalMsg
              id="ODd8bB"
              defaultMessage="Shop Sale"
              description={{
                text: "Button to go to the Sale page",
                img: "https://cdn.faire.com/fastly/35aba944cb5cb2ad3e39b01a499759801eee71ea93bb8b7df0008f8d64126c0d.png",
              }}
            />
          </Button>
        }
      />
    </ClickOutside>
  );
};

const useGetTooltipContent = (isSalesHubPowerUser?: boolean) => {
  const { strictLocalize } = useStrictLocalization();
  if (isSalesHubPowerUser) {
    return [
      {
        title: strictLocalize({
          id: "SE1FXV",
          defaultMessage: "New! Find even more deals in Sale",
          description: {
            text: "Header for a tooltip for updated Sales tab in navigation bar",
            img: "https://cdn.faire.com/fastly/27d244538e1352139a1c50db25becfa9ab9b1c079e9b071a5bc9cfc7e516b1c7.png",
          },
        }),
        body: strictLocalize({
          id: "8WiNzV",
          defaultMessage:
            "In addition to flash deals, the deepest discounts on Faire, you’ll now find all brand promotions in Sale.",
          description: {
            text: "Description for a tooltip for Sales tab in navigation bar",
            img: "https://cdn.faire.com/fastly/27d244538e1352139a1c50db25becfa9ab9b1c079e9b071a5bc9cfc7e516b1c7.png",
          },
        }),
      },
    ];
  }
  return [
    {
      title: strictLocalize({
        id: "+MnV+p",
        defaultMessage: "Sale got an upgrade!",
        description: {
          text: "Header for a tooltip for updated Sales tab in navigation bar",
          img: "https://cdn.faire.com/fastly/35aba944cb5cb2ad3e39b01a499759801eee71ea93bb8b7df0008f8d64126c0d.png",
        },
      }),
      body: strictLocalize({
        id: "DO07VR",
        defaultMessage:
          "Explore all brand promotions and our flash deals, the deepest discounts on Faire. Go to the Sale tab to start saving.",
        description: {
          text: "Header for a tooltip for Sales tab in navigation bar",
          img: "https://cdn.faire.com/fastly/35aba944cb5cb2ad3e39b01a499759801eee71ea93bb8b7df0008f8d64126c0d.png",
        },
      }),
    },
  ];
};

const StyledTooltip = styled(DismissableTooltip)`
  position: absolute;
  // Center tooltip on "Sale" link
  bottom: 10px;
  left: 0;
  right: 0;
`;
